import { render, staticRenderFns } from "./MerchProductDialog.vue?vue&type=template&id=126a0846"
import script from "./MerchProductDialog.vue?vue&type=script&lang=js"
export * from "./MerchProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports